import { render, staticRenderFns } from "./SalesDepartmentUKbranch.vue?vue&type=template&id=f9c5f736"
import script from "./SalesDepartmentUKbranch.vue?vue&type=script&lang=js"
export * from "./SalesDepartmentUKbranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports